import { eventCreator } from './events'
import { apiCreator } from './api'
import { createPublicApi } from './public-api'
import type { DynamicPagesModule } from '@wix/wix-data-client-common'

const createModuleFactories: DynamicPagesModule['createModuleFactories'] =
  async services => ({
    getModuleName: () => 'dynamic-pages',
    createAppApi: ({ finalAppApiPromise }) =>
      apiCreator({ ...services, finalAppApiPromise }),
    createEventHandlers: ({ appApi }) => eventCreator({ ...services, appApi }),
  })

const publicApi = createPublicApi()

export default { createModuleFactories, publicApi }
